export default __webpack_public_path__ + "assets/Edit.2c94.svg";